/**
 * Legacy module shell — kept so AngularJS modules that declare
 * 'acme.common.service.templates.helpers' as a dependency keep bootstrapping.
 *
 * The real implementation lives at:
 *   apps/b2b-frontend/app/core/templates/helpers/templates-helpers.service.ts
 *
 * It is registered with AngularJS via downgradeInjectable in
 *   apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts
 * so any $inject = ['TemplatesHelpersService'] still resolves to the Angular 18 class.
 *
 * Loaded automatically by ui/src/legacy.ts (require.context).
 */
angular.module('acme.common.service.templates.helpers', [
  'acme.common.service.calendar',
  'acme.common.service.helpers',
  'acme.common.service.userPreferences',
]);
